export default __webpack_public_path__ + "static/media/Beef-Croquette.1e05e130.jpg";